module.exports = __webpack_public_path__ + "img/sv1.f5afc55d.png";